<div *ngIf='componentReady' class='RegisterStepPay__wrapper'>
  <div class='RegisterStepPay__wrapper__container'>
    <h3>Payment</h3>
    <p class='text-center mt-3 font-weight-bolder'>
      Complete the payment information to proceed to the next step.
    </p>
    <div
      [formGroup]='registerForm'
      class='RegisterStepPay__wrapper__container__form mt-5'>
      <div class='row'>
        <div class='col'>
          <app-text-field
            formControlName='card_name'
            placeholder='Name on card'></app-text-field>
          <div
            *ngIf='
              (card_name.dirty && card_name.touched && card_name.invalid) ||
              (paymentErrors && paymentErrors.card_name)
            '
            class='alert alert-danger'>
            <p
              *ngIf='card_name.errors && card_name.errors.required'
              class='mb-0'>
              Card Holder name is required
            </p>
            <p *ngIf='paymentErrors.card_name' class='mb-0'>
              Card Holder is invalid
            </p>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col'>
          <app-text-field
            formControlName='card_number'
            placeholder='Card Number...(16 caracters)'></app-text-field>
          <div
            *ngIf='
              (card_number.dirty &&
                card_number.touched &&
                card_number.invalid) ||
              (paymentErrors && paymentErrors.card_number)
            '
            class='alert alert-danger'>
            <p
              *ngIf='card_number.errors && card_number.errors.required'
              class='mb-0'>
              Card Holder name is required
            </p>
            <p *ngIf='paymentErrors.card_number' class='mb-0'>
              Card Holder is invalid
            </p>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-md-6'>
          <app-select
            [defaultValue]='currentMonth'
            [items]='months'
            formControlName='expire_month'
            label='Expire Month (MM)'></app-select>
        </div>
        <div class='col col-md-6'>
          <app-select
            [defaultValue]='currentYear'
            [items]='years'
            formControlName='expire_year'
            label='Expire Year (YY)'></app-select>
        </div>
      </div>
      <div *ngIf='paymentErrors && paymentErrors.exp_period' class='row mt-3'>
        <div class='alert alert-danger'>
          <p class='mb-0'>Card Expiration Date is invalid</p>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col'>
          <app-text-field
            formControlName='card_id'
            placeholder='CVV Code'></app-text-field>
          <div
            *ngIf='
              (card_id.dirty && card_id.touched && card_id.invalid) ||
              (paymentErrors && paymentErrors.card_id)
            '>
            <div class='alert alert-danger'>
              <p *ngIf='card_id.errors && card_id.errors.required' class='mb-0'>
                Card Security Code name is required
              </p>
              <p *ngIf='card_id.errors && card_id.errors.pattern' class='mb-0'>
                Card Security Code should contains only digits
              </p>
              <p
                *ngIf='
                  card_id.errors &&
                  (card_id.errors.minlength || card_id.errors.maxlength)
                '
                class='mb-0'>
                Card Security Code should be 3 or 4 digits
              </p>
              <p *ngIf='paymentErrors && paymentErrors.card_id' class='mb-0'>
                Card Security Code is invalid
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class='row mt-3'>
        <div class='col col-12 col-sm-6'>
          <h4 class='text-center'>Select Plan</h4>
          <div class='row mt-3'>
            <div class='col col-12'>
              <app-select (selection)='onPlanChange($event)' [items]='getPlanItems()' formControlName='plan_id'
                          label='Select your plan'></app-select>
            </div>
            <div class='col col-12 mt-3'>
              <app-text-field formControlName='discount' placeholder='Team Code'></app-text-field>
            </div>
          </div>
        </div>
        <div class='col col-12 col-sm-6'>
          <div *ngIf='selectedPlan' class='PlanPreview d-flex flex-column mt-5 p-3'>
            <div class='PlanPreview__title'>
              {{ selectedPlan.name }}
            </div>
            <ng-container *ngIf='discount.value; else showPrice'>
              <div class='PlanPreview__price mt-3'>
                <span class='font-weight-bolder'>Teamcode will be applied and shown on next screen.</span>
              </div>
            </ng-container>
            <ng-template #showPrice>
              <div class='PlanPreview__price mt-3'>
                <span class='font-weight-bolder'>$ {{ selectedPlan.fee }}</span>
                <span class='text-muted'> / {{ selectedPlan.period }}</span>
              </div>
              <div class='PlanPreview__price'>
                <span class='font-weight-bolder'>$ {{ selectedPlan.setup_fee }}</span>
                <span class='text-muted'> set up</span>
              </div>
            </ng-template>
            <p class='PlanPreview__pointer mt-3 text-muted'>up to {{ selectedPlan.contacts_limit }} contacts</p>
            <p class='PlanPreview__pointer text-muted'>{{ selectedPlan.send_limit }} emails sent per day</p>
            <p *ngIf='selectedPlan.vsm' class='PlanPreview__pointer text-muted'>Dedicated EDGE support</p>
          </div>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col'>
          <app-button
            #buttonComponent
            [Click]='submitForm'
            [color]="'orange'"
            [observeApi]='true'
            [size]="'normal'"
            [style]="'rounded'"
            [text]="'next'"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
